import axios from "axios";
import { prefilledRenter } from "../helpers/prefilledRenter";
import { coRenterState } from "../helpers/coRenterState";
import { initialState } from "./initialState";

const CREATE_CORENTER_STARTED = "CREATE_CORENTER_STARTED";
const CREATE_CORENTER_SUCCESS = "CREATE_CORENTER_SUCCESS";
const CREATE_CORENTER_FAILURE = "CREATE_CORENTER_FAILURE";

const CREATE_CORENTER_REFERENCE_STARTED = "CREATE_CORENTER_REFERENCE_STARTED";
const CREATE_CORENTER_REFERENCE_FAILURE = "CREATE_CORENTER_REFERENCE_FAILURE";
const CREATE_CORENTER_REFERENCE_SUCCESS = "CREATE_CORENTER_REFERENCE_SUCCESS";

const COPY_RENTER_FIELDS_STARTED = "COPY_RENTER_FIELDS_STARTED";
const COPY_RENTER_FIELDS_SUCCESS = "COPY_RENTER_FIELDS_SUCCESS";
const COPY_RENTER_FIELDS_FAILURE = "COPY_RENTER_FIELDS_FAILURE";

const UPDATE_CORENTER_REFERENCE_STARTED = "UPDATE_CORENTER_REFERENCE_STARTED";
const UPDATE_CORENTER_REFERENCE_FAILURE = "UPDATE_CORENTER_REFERENCE_FAILURE";

const UPDATE_CORENTER = "UPDATE_CORENTER";
const UPDATE_CORENTER_REFERENCE = "UPDATE_CORENTER_REFERENCE";

const POST_CORENTER_IMAGE_SUCCESS = "POST_CORENTER_IMAGE_SUCCESS";
const POST_CORENTER_IMAGE_FAILURE = "POST_CORENTER_IMAGE_FAILURE";
const POST_CORENTER_IMAGE_STARTED = "POST_IMAGE_STARTED";

const DELETE_CORENTER_STARTED = "DELETE_CORENTER_STARTED";
const DELETE_CORENTER_SUCCESS = "DELETE_CORENTER_SUCCESS";
const DELETE_CORENTER_FAILURE = "DELETE_CORENTER_FAILURE";

const DELETE_CORENTER_IMAGE_SUCCESS = "DELETE_CORENTER_IMAGE_SUCCESS";
const DELETE_CORENTER_IMAGE_FAILURE = "DELETE_CORENTER_IMAGE_FAILURE";
const DELETE_CORENTER_IMAGE_STARTED = "DELETE_CORENTER_IMAGE_STARTED";

const SAVE_CORENTER_FAILURE = "SAVE_CORENTER_FAILURE";

const PREFILL_CORENTER = "PREFILL_CORENTER";

export function copyRenterFields(contractId, coRenterId, fields) {
  return (dispatch) => {
    dispatch(copyRenterFieldsStarted());

    axios
      .put(`/contracts/${contractId}/co-renter/`, {
        ...fields,
        renter_id: coRenterId,
      })
      .then(() => dispatch(copyRenterFieldsSuccess(fields)))
      .catch((err) =>
        dispatch(copyRenterFieldsFailure(err.response.data.ui_message))
      );
  };
}

const copyRenterFieldsStarted = () => ({ type: COPY_RENTER_FIELDS_STARTED });
const copyRenterFieldsFailure = (error) => ({
  type: COPY_RENTER_FIELDS_FAILURE,
  payload: error,
});
const copyRenterFieldsSuccess = (payload) => ({
  type: COPY_RENTER_FIELDS_SUCCESS,
  payload,
});

export function saveCoRenterReference(contractId, refId, refData, idx) {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/update-reference/`, {
        reference_id: refId,
        ...refData,
      })
      .then(() =>
        dispatch(
          updateCoRenterReference({
            name: Object.keys(refData)[0],
            value: refData[Object.keys(refData)[0]],
            idx,
          })
        )
      )
      .catch((err) =>
        dispatch(updateCoRenterReferenceFailure(err.response.data.ui_message))
      );
  };
}

const updateCoRenterReferenceFailure = (err) => ({
  type: UPDATE_CORENTER_REFERENCE_FAILURE,
  payload: err,
});

export function createCoRenterReference(
  contractId,
  renterId,
  refIdx,
  referenceData
) {
  return (dispatch) => {
    axios
      .post(`/contracts/${contractId}/add-reference/`, {
        contract_id: contractId,
        corenter_id: renterId,
        ...referenceData,
      })
      .then(({ data }) =>
        dispatch(createCoRenterReferenceSuccess(data.id, refIdx, referenceData))
      )
      .catch((err) =>
        dispatch(createCoRenterReferenceFailure(err.response.data.ui_message))
      );
  };
}

const createCoRenterReferenceSuccess = (refId, refIdx, referenceData) => ({
  type: CREATE_CORENTER_REFERENCE_SUCCESS,
  payload: {
    refId,
    refIdx,
    ...referenceData,
  },
});

const createCoRenterReferenceFailure = (err) => ({
  type: CREATE_CORENTER_REFERENCE_FAILURE,
  payload: err,
});

export function createCoRenter(contractId, email) {
  return (dispatch) => {
    dispatch(createCoRenterStarted());

    axios
      .post(`/contracts/${contractId}/co-renter/`, { email })
      .then(({ data }) =>
        dispatch(createCoRenterSuccess(data.renter_id, email))
      )
      .catch((err) =>
        dispatch(createCoRenterFailure(err.response.data.ui_message))
      );
  };
}

const createCoRenterSuccess = (id, email) => ({
  type: CREATE_CORENTER_SUCCESS,
  payload: { id, email },
});

const createCoRenterFailure = (err) => ({
  type: CREATE_CORENTER_FAILURE,
  payload: err,
});

const createCoRenterStarted = () => ({ type: CREATE_CORENTER_STARTED });

export function prefillCoRenter() {
  return {
    type: PREFILL_CORENTER,
    payload: prefilledRenter,
  };
}

export function saveCoRenter(contractId, renterId, renterData) {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/co-renter/`, {
        ...renterData,
        renter_id: renterId,
      })
      .then(() => dispatch(updateCoRenter(renterData)))
      .catch((err) =>
        dispatch(saveCoRenterFailure(err.response.data.ui_message))
      );
  };
}

const saveCoRenterFailure = (err) => ({
  type: SAVE_CORENTER_FAILURE,
  payload: err,
});

export function updateCoRenter(coRenter) {
  return { type: UPDATE_CORENTER, payload: coRenter };
}

export function updateCoRenterReference(reference) {
  return { type: UPDATE_CORENTER_REFERENCE, payload: reference };
}

export function deleteCoRenter(requestData) {
  return (dispatch) => {
    dispatch({ type: DELETE_CORENTER_STARTED });

    axios
      .post(`/delete-corenter-from-contract/`, { ...requestData })
      .then(() => dispatch({ type: DELETE_CORENTER_SUCCESS }))
      .catch((err) =>
        dispatch({
          type: DELETE_CORENTER_FAILURE,
          payload: err.response.data.ui_message,
        })
      );
  };
}

export const deleteCoRenterImage = (postData) => {
  return (dispatch) => {
    dispatch(deleteCoRenterImageStarted());

    axios
      .delete(postData.url)
      .then(({ data }) => {
        dispatch(deleteCoRenterImageSuccess(postData.keyName));
      })
      .catch((err) => {
        dispatch(deleteCoRenterImageFailure(err.response.data.ui_message));
      });
  };
};

const deleteCoRenterImageStarted = () => ({
  type: DELETE_CORENTER_IMAGE_STARTED,
});

const deleteCoRenterImageFailure = (error) => ({
  type: DELETE_CORENTER_IMAGE_FAILURE,
  payload: error,
});

const deleteCoRenterImageSuccess = (imageKeyName) => ({
  type: DELETE_CORENTER_IMAGE_SUCCESS,
  payload: imageKeyName,
});

export const postCoRenterImage = (postData) => {
  return (dispatch) => {
    dispatch(postCoRenterImageStarted());

    axios
      .post(postData.url, postData.imageData)
      .then(({ data }) => {
        dispatch(
          postCoRenterImageSuccess({
            // image: data[postData.responseKey],
            image: {
              ...data,
            },
            key: postData.responseKey,
          })
        );
      })
      .catch((err) => {
        dispatch(postCoRenterImageFailure(err.response.data.ui_message));
      });
  };
};

const postCoRenterImageStarted = () => ({ type: POST_CORENTER_IMAGE_STARTED });

const postCoRenterImageFailure = (error) => ({
  type: POST_CORENTER_IMAGE_FAILURE,
  payload: error,
});

const postCoRenterImageSuccess = (image) => ({
  type: POST_CORENTER_IMAGE_SUCCESS,
  payload: image,
});

function coRenterReducer(state, action) {
  switch (action.type) {
    case COPY_RENTER_FIELDS_STARTED:
      return {
        ...state,
        loading: true,
      };
    case COPY_RENTER_FIELDS_SUCCESS:
      return {
        ...state,
        coRenter: {
          ...state.coRenter,
          ...action.payload,
        },
        loading: false,
      };
    case COPY_RENTER_FIELDS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CREATE_CORENTER_REFERENCE_STARTED:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CORENTER_REFERENCE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CREATE_CORENTER_REFERENCE_SUCCESS:
      const refs = [...state.coRenter.references];
      const createdRef = refs[action.payload.refIdx];
      createdRef.id = action.payload.refId;

      return {
        ...state,
        loading: false,
        coRenter: {
          ...state.coRenter,
          references: refs,
        },
      };
    case CREATE_CORENTER_STARTED:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CORENTER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CREATE_CORENTER_SUCCESS:
      return {
        ...state,
        loading: false,
        coRenter: {
          ...coRenterState,
          email: action.payload.email,
          id: action.payload.id,
          references: [
            {
              id: null,
              email: "",
              first_name: "",
              last_name: "",
              phone: "",
              relationship: "",
            },
            {
              id: null,
              email: "",
              first_name: "",
              last_name: "",
              phone: "",
              relationship: "",
            },
          ],
        },
      };
    case DELETE_CORENTER_STARTED:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CORENTER_SUCCESS:
      return {
        ...state,
        loading: false,
        coRenter: null,
      };
    case DELETE_CORENTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_CORENTER_IMAGE_STARTED:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CORENTER_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_CORENTER_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coRenter: {
          ...state.coRenter,
          [action.payload]: null,
        },
      };
    case POST_CORENTER_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coRenter: {
          ...state.coRenter,
          [action.payload.key]: {
            ...action.payload.image,
            supplemental_documents: [],
          },
        },
      };
    case POST_CORENTER_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_CORENTER_IMAGE_STARTED:
      return {
        ...state,
        loading: true,
      };
    case PREFILL_CORENTER:
      return {
        ...state,
        coRenter: {
          ...action.payload,
          id: state.coRenter.id,
        },
      };
    case SAVE_CORENTER_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_CORENTER:
      return {
        ...state,
        coRenter: {
          ...state.coRenter,
          ...action.payload,
        },
      };
    case UPDATE_CORENTER_REFERENCE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_CORENTER_REFERENCE:
      const newCoRenterRefs = [...state.coRenter.references];
      const nf = newCoRenterRefs[action.payload.idx];
      nf[action.payload.name] = action.payload.value;

      return {
        ...state,
        coRenter: {
          ...state.coRenter,
          references: newCoRenterRefs,
        },
      };
    default:
      return state;
  }

  return state;
}

export default coRenterReducer;
